var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#9e9e9e",
      fillOpacity: 1
    },
    d: "M20 1.332H5.332A2.676 2.676 0 0 0 2.668 4v17.332c0 .734.598 1.336 1.332 1.336.734 0 1.332-.602 1.332-1.336v-16c0-.73.602-1.332 1.336-1.332H20c.734 0 1.332-.602 1.332-1.332 0-.734-.598-1.336-1.332-1.336Zm5.332 5.336H10.668A2.673 2.673 0 0 0 8 9.332V28c0 1.465 1.2 2.668 2.668 2.668h14.664A2.677 2.677 0 0 0 28 28V9.332c0-1.465-1.2-2.664-2.668-2.664ZM24 28H12a1.336 1.336 0 0 1-1.332-1.332v-16c0-.734.598-1.336 1.332-1.336h12c.734 0 1.332.602 1.332 1.336v16c0 .73-.598 1.332-1.332 1.332Zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content-copy.95944fbae1f2ad693b6b40d0c1bf5339.svg";
export { ForwardRef as ReactComponent };